import { render } from "./DiagnosisSetupChecklist.vue?vue&type=template&id=1a4865bd&scoped=true"
import script from "./DiagnosisSetupChecklist.vue?vue&type=script&lang=js"
export * from "./DiagnosisSetupChecklist.vue?vue&type=script&lang=js"

import "./DiagnosisSetupChecklist.vue?vue&type=style&index=0&id=1a4865bd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4865bd"]])

export default __exports__